<template>
  <BaseEdit
    @edit-confirm-action="updateEntry"
    @edit-cancel-action="resetForm"
    @edit-open-action="loadServerEntry(entry.id)"
    @clear-form-errors="clearFormErrors"
    ref="baseEdit"
    editTitle="Edição de Embalagem"
    width="50%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :readOnly="readOnly"
    :modelNameSingular="modelNameSingular"
  >
    <template slot="editForm">
      <Form
        ref="form"
        :entry="editableEntry"
        :extraData="extraData"
        :readOnly="readOnly"
        :isEdit="isEdit"
        :modelNameSingular="modelNameSingular"
      />
    </template>
  </BaseEdit>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseEdit from "@shared_components/base_edit.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      editableEntry: null,
      formErrors: [],
      extraData: null
    };
  },
  props: {
    entry: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    Form: Form,
    BaseEdit: BaseEdit
  },
  methods: {
    loadServerEntry: function(id) {
      this.editableEntry = null;
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_PACKAGING_QUERY,
          fetchPolicy: "no-cache",
          variables: {
            id: id
          }
        })
        .then(response => {
          this.editableEntry = response.data.accountGlobalSharedContext.packaging;
          this.extraData = response.data;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));

    },
    updateServerEntry: function(packaging) {
      this.pageLoading = true;
      this.$apollo
        .mutate({
          mutation: UPDATE_PACKAGING_MUTATION,
          variables: {
            input: this.deepFilterEntryWithAllowedFieldsForMutation(packaging, this.editableEntry.validations)
          }
        })
        .then(response => {
          var errors = response.data.updatePackaging.errors
          if (errors.length){
            this.formErrors = errors
          } else {
            this.$refs.baseEdit.closeDialog();
            this.$emit("entry-updated");
          }
        })
        .catch(response => console.log(response))
        .finally(() => (this.pageLoading = false));
    },
    updateEntry: function() {
      if (this.$refs.form.isFormValid()){
        this.updateServerEntry(this.editableEntry);
        this.resetForm();
      }
    },
    resetForm: function() {
      this.$refs.form.resetFormInputs();
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};
const LOAD_PACKAGING_QUERY = gql `
  query ($id: ID!) { 
    accountGlobalSharedContext {
      packaging(id: $id) {
        id
        packagingTypeId
        packagingType {
          id
          name
        }
        size
        unitId
        customUnitId
        unit {
          id
          name
        }
        validations
      }
    }
    globalContext {
      allPackagingTypes {
        id
        name
        shortName
        description
      }
      allUnits {
        id
        name
        fullName
      }
      allCustomUnits{
        id
        name
      }
    }
  }
`;

const UPDATE_PACKAGING_MUTATION = gql `
  mutation($input: PackagingUpdateInputObject!) {
    updatePackaging(input: $input) {
      packaging {
        id
      }
      errors
    }
  }
`;

</script>

<style scoped></style>